<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import PaginationControl from '../PaginationControl/PaginationControl.vue';
import ContractManagementItem from '../ContractManagementItem/ContractManagementItem.vue';
import ContractManagementListFilters from '../ContractManagementListFilters/ContractManagementListFilters.vue';

export default Vue.extend({
    components: {
        DropdownMenu,
        PaginationControl,
        ContractManagementItem,
        ContractManagementListFilters
    },
    computed: {
        ...mapState({
            items: state => state.contract.overview.items,
            limits: state => state.contract.overview.limits,
            limit: state => state.contract.overview.limit,
            filter: state => state.contract.overview.filter,
            filters: state => state.contract.overview.filters,
            page: state => state.contract.overview.page,
            year: state => state.contract.overview.year,
            years: state => state.contract.overview.years,
            show: state => state.contract.overview.show,
            showList: state => state.contract.overview.showList,
            search: state => state.contract.overview.search,
        }),
        ...mapGetters({
            contractListFilteredPaginated: 'contract/contractListFilteredPaginated',
            contractListMaxPages: 'contract/contractListMaxPages'
        })
    },
    mounted () {
        this.contractManagementListSearchSet('');
    },
    methods: {
        ...mapActions({
            contractManagementListShowSet: 'contract/contractManagementListShowSet',
            contractManagementListLimitSet: 'contract/contractManagementListLimitSet',
            contractManagementListYearSet: 'contract/contractManagementListYearSet',
            contractManagementListSearchSet: 'contract/contractManagementListSearchSet',
            contractManagementListFilterSelect: 'contract/contractManagementListFilterSelect',
            contractManagementListPageIncrement: 'contract/contractManagementListPageIncrement',
            contractManagementListPageDecrement: 'contract/contractManagementListPageDecrement',
            contractManagementListContractSelect: 'contract/contractManagementListContractSelect',
            downloadContract: 'contract/downloadContract'
        })
    }
});
</script>
<template>
    <div class="contract-management-list">
        <div :key="'body'" class="contract-management-list__body">
            <div class="contract-management-list__header">
                <div class="contract-management-list__heading">
                    {{ $t('contractManagement.list.heading.header') }}
                </div>
                <div class="contract-management-list__filters">
                    <contract-management-list-filters :contract-list-max-pages="contractListMaxPages"
                                                      :contract-list-page="page"
                                                      :show="show"
                                                      :show-list="showList"
                                                      :years="years"
                                                      :year="year"
                                                      :limits="limits"
                                                      :limit="limit"
                                                      :filters="filters"
                                                      :filter="filter"
                                                      :search="search"
                                                      @pageDecrement="contractManagementListPageDecrement"
                                                      @pageIncrement="contractManagementListPageIncrement"
                                                      @setShow="contractManagementListShowSet"
                                                      @setYear="contractManagementListYearSet"
                                                      @setFilter="contractManagementListFilterSelect"
                                                      @setLimit="contractManagementListLimitSet"
                                                      @search="contractManagementListSearchSet"/>
                </div>
            </div>
            <table class="contract-management-list__table">
                <thead>
                    <tr>
                        <th>{{ $t('contractManagement.list.supplier') }}</th>
                        <th>{{ $t('contractManagement.list.status.label') }}</th>
                        <th>{{ $t('contractManagement.list.lastUpdated') }}</th>
                        <th>{{ $t('contractManagement.list.updatedBy') }}</th>
                        <th/>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(contract, index) in contractListFilteredPaginated" :key="index">
                        <td>{{ contract.supplierName }}</td>
                        <td>{{ $t('contractManagement.list.status.' + contract.status) }}</td>
                        <td><span v-if="contract.lastModifiedAt">{{ contract.lastModifiedAt | moment("DD/MM/Y\, HH:mm") }}</span></td>
                        <td><span v-if="contract.lastModifiedBy">{{ contract.lastModifiedBy }}</span></td>
                        <td>
                            <router-link :to="{name: 'contractManagement', params: {contractId: contract.contractId, supplierId: contract.supplierId}}"
                                         class="contract-management-list__btn contract-management-list__btn-edit">
                                <span>{{ $t('contractManagement.list.edit') }}</span>
                            </router-link>
                            <router-link v-if="!contract.contractS3 && contract.readyForReview" :to="{name: 'contract', params: {contractId: contract.contractId, supplierId: contract.supplierId}}"
                                         class="contract-management-list__btn contract-management-list__btn-edit">
                                <span v-if="!contract.readyForSupplier">{{ $t('contractManagement.list.view') }}</span>
                                <span v-if="contract.readyForSupplier">{{ $t('contractManagement.list.viewSupplier') }}</span>
                            </router-link>
                            <div v-if="contract.contractS3" class="contract-management-list__btn contract-management-list__btn-download" @click="downloadContract(contract.contractS3)">
                                {{ $t('contractManagement.list.download') }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="contract-management-list__items">
                <div class="contract-management-list__items-list">
                    <contract-management-item v-for="contract in contractListFilteredPaginated"
                                              :key="contract.contractId"
                                              :supplier="contract.supplierName"
                                              :contract-id="contract.contractId"
                                              :supplier-id="contract.supplierId"
                                              :status="contract.status"
                                              :last-updated="contract.lastModifiedAt"
                                              :updated-by="contract.lastModifiedBy"
                                              :url="contract.contractS3"/>
                </div>
            </div>
            <div v-if="!contractListFilteredPaginated.length" :key="'no-content'" class="contract-management-list__error">
                <i class="fa fa-bullhorn"/>
                <div class="contract-management-list__error-message">{{ $t('contractManagement.list.noContracts') }}</div>
            </div>
            <div class="contract-management-list__footer">
                <div class="contract-management-list__pagination">
                    <pagination-control :max-pages="contractListMaxPages"
                                        :current-page="page"
                                        @prev="contractManagementListPageDecrement"
                                        @next="contractManagementListPageIncrement"/>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementList/ContractManagementList.vue